// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__ZQhtr","emails":"CreateEditClinics_emails__5rU_u","emailTagLabel":"CreateEditClinics_emailTagLabel__3FHzO"};